import { create } from 'zustand';

export type ToolMode = 'select' | 'move' | 'rotate' | 'scale' | 'pan' | 'annotate' | 'draw';
export type SafeZoneAspect = '16:9' | '9:16' | '4:3' | '1:1' | null;
export type BoneMode = 'off' | 'on' | 'only';

interface ToolState {
  activeTool: ToolMode;
  boneMode: BoneMode;
  gridVisible: boolean;
  snapEnabled: boolean;
  safeZoneAspect: SafeZoneAspect;
  isPresentationMode: boolean;
  setTool: (mode: ToolMode) => void;
  cycleBoneMode: () => void;
  toggleGrid: () => void;
  toggleSnap: () => void;
  setSafeZone: (aspect: SafeZoneAspect) => void;
  togglePresentationMode: () => void;
  exitPresentationMode: () => void;
}

const BONE_CYCLE: BoneMode[] = ['off', 'on', 'only'];

export const useToolStore = create<ToolState>((set) => ({
  activeTool: 'select',
  boneMode: 'off',
  gridVisible: false,
  snapEnabled: false,
  safeZoneAspect: null,
  isPresentationMode: false,
  setTool: (mode) => set({ activeTool: mode }),
  cycleBoneMode: () => set((s) => ({
    boneMode: BONE_CYCLE[(BONE_CYCLE.indexOf(s.boneMode) + 1) % BONE_CYCLE.length],
  })),
  toggleGrid: () => set((s) => ({ gridVisible: !s.gridVisible })),
  toggleSnap: () => set((s) => ({ snapEnabled: !s.snapEnabled })),
  setSafeZone: (aspect) => set({ safeZoneAspect: aspect }),
  togglePresentationMode: () => set((s) => ({ isPresentationMode: !s.isPresentationMode })),
  exitPresentationMode: () => set({ isPresentationMode: false }),
}));
